import {
    NLGridLinkerDashboardContainer,
    TotalOrderWithoutCategoriesContainer,
} from "src/app/containers";

const LeadLinkerDashboard = () => {
    return (
        <div className="leadLinkerDashboard">
            <TotalOrderWithoutCategoriesContainer />
            <NLGridLinkerDashboardContainer />
        </div>
    );
};

export default LeadLinkerDashboard;
